import { apiSlice } from "../../../app/apiSlice";
import configUrls from "../../../config/configUrls";
import { ProcessoSetores, ProcessoSetoresList, ProcessoSobrestarDTO } from "../../../types/processo/ProcessoSetoresDTO";



const endpointUrl = configUrls.PROCESSO_EP

function sobrestarProcesso(obj: ProcessoSobrestarDTO) {
    return {
        url: `${endpointUrl}/sobrestar/create`,
        method: "POST",
        body: obj,
    }

}

function cancelarSobrestado({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/sobrestar/${id}`,
        method: "DELETE",
    }
}

function getSobrestados({ id, search }: { id: string, search: string }) {

    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }


    return {
        url: `${endpointUrl}/sobrestados/${id}?search=${search}`,
        method: "GET",
    }
}

function getSobrestado(id: string) {
    if (!id) {
        // Se 'processo' for null/undefined ou não tiver 'id', não faz a chamada à API.
        return {
            url: '',
            method: ''
        };
    }

    return {
        url: `${endpointUrl}/sobrestar/${id}`,
        method: "GET",
    }
}

function deleteSobrestado({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/sobrestar/${id}`,
        method: "DELETE",
    }
}

export const processoSobrestarApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({


        getSobrestados: query<ProcessoSetoresList[], { id: string, search: string }>({

            query: getSobrestados,
            providesTags: ["ProcessoSobrestar"],
        }),

        getSobrestado: query<ProcessoSetores, string>({
            //query: (id) => `${endpointUrl}/ciencia/${id}`,
            query: getSobrestado,
            providesTags: ["ProcessoSobrestar"],
        }),

        sobrestarProcesso: mutation<void, ProcessoSobrestarDTO>(
            {
                query: sobrestarProcesso,
                invalidatesTags: ["ProcessoSobrestar"]
            }),
        deleteSobrestado: mutation<void, { id: string }>(
            {
                query: deleteSobrestado,
                invalidatesTags: ["ProcessoSobrestar"],
            }),


    }),

});
export const {
    useGetSobrestadosQuery,
    useGetSobrestadoQuery,
    useSobrestarProcessoMutation,
    useDeleteSobrestadoMutation,
} = processoSobrestarApiSlice;
